import { render } from "./TopMessage.vue?vue&type=template&id=bdff761c&scoped=true&ts=true"
import script from "./TopMessage.vue?vue&type=script&lang=ts"
export * from "./TopMessage.vue?vue&type=script&lang=ts"

import "./TopMessage.vue?vue&type=style&index=0&id=bdff761c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdff761c"]])

export default __exports__